<template>
  <td>
    <v-flex d-flex align-center>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            class="mx-0"
            slot="activator"
            :ripple="{ class: 'error--text' }"
            @click="$router.push({name: 'EditCampaign', params: {id: campaign.id}})"
          >
            <v-icon small color="grey darken-1"> edit </v-icon>
          </v-btn>
        </template>
        <span>Edit</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small class="mx-0" slot="activator" @click="copyCampaign">
            <v-icon small color="grey darken-1"> file_copy </v-icon>
          </v-btn>
        </template>
        <span>Copy</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon small class="mx-0" slot="activator" @click="$emit('openDialog', campaign)">
            <v-icon small color="grey darken-1"> delete </v-icon>
          </v-btn>
        </template>
        <span>Archive</span>
      </v-tooltip>
    </v-flex>
  </td>
</template>

<script>
  import lodash from 'lodash'
  import moment from 'moment'
  import { mapActions } from 'vuex'
  export default {
    props: {
      campaign: {
        type: Object
      }
    },
    data () {
      return {}
    },
    methods: {
      copyCampaign (campaign) {
        const copy = lodash.cloneDeep(campaign)
        const payload = {
          start_time: moment(copy.start_time).format('YYYY-MM-DD hh:mm:ss'),
          end_time: moment().add(1, 'days').format('YYYY-MM-DD hh:mm:ss'),
          daily_budget: copy.daily_budget,
          lifetime_budget: copy.lifetime_budget,
          selectedBudget: copy.daily_budget ? 'daily_budget' : 'lifetime_budget',
          name: `${copy.name} - Copy`,
          objective: copy.objective,
          status: 'PAUSED',
          type: copy.adlabels,
          issues: copy.issues,
          messages: copy.messages,
          targeting: copy.targeting
        }
        this.createCampaign(payload)
      },
      ...mapActions([
        'createCampaign'
      ])
    }
  }
</script>
